class LegacyAuthDeniedError extends Error {
  constructor() {
    super("Legacy route authorization failed");
    this.name = "LegacyAuthDenied";
  }
}

export { LegacyAuthDeniedError };
